import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import type { Epic } from 'Flux/index.js'
import { invitationSlice } from 'Flux/Slice/Invitation/InvitationSlice.js'
import { InviteRepository } from 'Repository/index.js'

export const UpdateOrderCompletedNotificationEpic: Epic = (action$, state$, { [invitationSlice.name]: invites }) =>
  action$.pipe(
    filter(invites.updateOrderCompletedNotificationRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      InviteRepository.updateOrderCompletedNotification(action.payload).pipe(
        map((response) => invites.updateOrderCompletedNotificationRequestSuccess(response)),
        catchError((error) => of(invites.updateOrderCompletedNotificationRequestFailure(error)))
      )
    )
  )

export default UpdateOrderCompletedNotificationEpic
